module.exports = __webpack_public_path__ + "overlook-studios/img/CONCEPT-enemy_prototype_left_with_backgrounds_and_light_shake.gif";